let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("kHOMt"), load("hhss7"), load("Wowvf"), load("ffEVr"), load("9DDT5")]).then(() => parcelRequire('2TweP'));